import React from "react";
import styled from "styled-components";

const NoticeContainer = styled.section`
  justify-content: center;
  align-items: stretch;
  border-radius: 1em;
  display: flex;
  //width: 100%;
  padding: 1.5em;
  gap: 0.625em;
  background-color: #16191b;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 1.25em;
  }
`;

const NoticeContent = styled.div`
  display: flex;
  min-width: 15em;
  width: 100%;
  align-items: center;
  gap: 2.5em 6.25em;
  justify-content: space-between;
  flex-wrap: wrap;
  height: 100%;
  flex: 1;
  flex-shrink: 1;
  flex-basis: 0%;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const MainInfo = styled.div`
  align-self: stretch;
  display: flex;
  min-width: 15em;
  margin-top: auto;
  margin-bottom: auto;
  align-items: center;
  gap: 1em;
  justify-content: start;
  flex-wrap: wrap;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const IconContainer = styled.div`
  align-self: stretch;
  margin-top: auto;
  margin-bottom: auto;
  overflow: hidden;
  width: 5.375em;
`;

const Icon = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 5.375em;
`;

const TextContent = styled.div`
  align-self: stretch;
  display: flex;
  min-width: 15em;
  margin-top: auto;
  margin-bottom: auto;
  flex-direction: column;
  align-items: stretch;
  font-family: Manrope, -apple-system, Roboto, Helvetica, sans-serif;
  justify-content: center;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const Title = styled.h2`
  color: #fff;
  font-size: 1.25em;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.025em;
  margin: 0;
`;

const Description = styled.p`
  color: #717981;
  font-size: 1em;
  font-weight: 500;
  line-height: 1;
  letter-spacing: -0.02em;
  margin-top: 0.625em;
  margin-bottom: 0;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const Timestamp = styled.div`
  color: #717981;
  text-align: right;
  font-family: Manrope, -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 1em;
  font-weight: 500;
  line-height: 1.375em;
  letter-spacing: -0.02em;
  align-self: stretch;
  margin-top: auto;
  margin-bottom: auto;
`;

const MaintenanceNotice = () => {
  return (
    <NoticeContainer role="banner" aria-label="Maintenance notification">
      <NoticeContent>
        <MainInfo>
          <IconContainer>
            <Icon src="/images/techWork.svg" alt="tech work icon" />
          </IconContainer>
          <TextContent>
            <Title>Technical work is underway!</Title>
            <Description>
              Due to technical work on the website, most of its functionality is currently unavailable.
            </Description>
          </TextContent>
        </MainInfo>
        <Timestamp>
          Expected completion time:<br />
          04.06.2025 10:00 UTC
        </Timestamp>
      </NoticeContent>
    </NoticeContainer>
  );
};

export default MaintenanceNotice;
